import { ProductImageUploadView } from './product_image_upload_view';
import { ProductImageView } from './product_image_view';

$('div#view').on('viewready', (element) => {
  const recordID = element.target.view!.record_id!;
  window.lsCloud.Config.access('cloudinary_name').done((name) => {
    $.cloudinary.config({ cloud_name: name });
    $.when(window.merchantos.session.getImageUsage()).done(() => {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number' is not assignab... Remove this comment to see the full error message
      window.merchantos.image = new ProductImageView(recordID);
    });
  });
});

// @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof ProductImageUploadView' is missing th... Remove this comment to see the full error message
window.ProductImageUploadView = ProductImageUploadView;
